import React from 'react';
import { useWeb3 } from '../context/Web3Context';
import { Wallet, LogOut, AlertTriangle, Loader2 } from 'lucide-react';
import { Button } from './ui/button';

export const ConnectWallet = ({ compact = false }) => {
  const { walletAddress, shortAddress, isConnecting, isPolygonNetwork, connectWallet, disconnect, switchToPolygon, isMetaMaskInstalled } = useWeb3();

  if (walletAddress) {
    return (
      <div className="flex items-center gap-2">
        {!isPolygonNetwork && (
          <button
            onClick={() => switchToPolygon()}
            className="flex items-center gap-1 px-2 py-1 text-xs bg-amber-500/20 text-amber-400 rounded hover:bg-amber-500/30 transition-colors"
            data-testid="switch-network-btn"
          >
            <AlertTriangle size={12} />
            Switch to Polygon
          </button>
        )}
        <div
          className="flex items-center gap-2 px-3 py-1.5 bg-emerald-500/10 border border-emerald-500/30 rounded text-sm cursor-pointer hover:bg-emerald-500/20 transition-colors"
          onClick={disconnect}
          title="Click to disconnect"
          data-testid="wallet-connected"
        >
          <div className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
          <span className="text-emerald-400 font-mono text-xs">{shortAddress}</span>
          <LogOut size={12} className="text-emerald-400/60" />
        </div>
      </div>
    );
  }

  if (compact) {
    return (
      <button
        onClick={connectWallet}
        disabled={isConnecting}
        className="flex items-center gap-2 px-3 py-1.5 bg-[#1A1A1A] border border-[#262626] rounded text-sm text-muted-foreground hover:text-gold hover:border-gold/30 transition-colors"
        data-testid="connect-wallet-btn"
      >
        {isConnecting ? <Loader2 size={14} className="animate-spin" /> : <Wallet size={14} />}
        {isConnecting ? 'Connecting...' : 'Connect Wallet'}
      </button>
    );
  }

  return (
    <Button
      onClick={connectWallet}
      disabled={isConnecting}
      className="bg-gradient-to-r from-[#627EEA] to-[#3B5998] hover:from-[#5570D0] hover:to-[#2E4880] text-white"
      data-testid="connect-wallet-btn"
    >
      {isConnecting ? (
        <>
          <Loader2 size={16} className="mr-2 animate-spin" />
          Connecting...
        </>
      ) : (
        <>
          <Wallet size={16} className="mr-2" />
          Connect MetaMask
        </>
      )}
    </Button>
  );
};
